import { prop, pick } from 'ramda';
import { setCookie } from 'js/utils/cookie.util';
import { getBaseDomain } from 'js/utils/url.util';
import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { storageService } from 'js/services/storage.service';
import { useAppSelector, useCookieSettingsSelector } from 'js/store/hooks';

import * as helpers from '../helpers';

export const useSetCommonCookie = () => {
    const {
        defaultCookieName,
        storageCookieName,
        cookieExpirationDays
    } = useCookieSettingsSelector(pick(['defaultCookieName', 'storageCookieName', 'cookieExpirationDays']));
    const {
        cookieGroups,
        commonCookieName,
        enablePresistentCookieLayer
    } = useAppSelector(prop('cookiesConfiguration'));

    useEffectOnce(() => {
        const defaultCookiesGroups = helpers.parseCookiesGroups(cookieGroups);
        const storageCookiesGroups = storageService.local.getItem(storageCookieName) || {};
        const isNotSetCommonCookie = Object.keys(defaultCookiesGroups)
            .every((key) => Object.keys(storageCookiesGroups).includes(key));

        if (isNotSetCommonCookie || !enablePresistentCookieLayer) {
            return;
        }

        setCookie(
            commonCookieName || defaultCookieName,
            0,
            { expires: cookieExpirationDays, path: '/', domain: getBaseDomain() }
        );
    }, [
        cookieGroups, storageCookieName, commonCookieName,
        defaultCookieName, cookieExpirationDays, enablePresistentCookieLayer
    ]);
};
